import { FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GENETIC_COUNSELING_TRANSLATION } from '@/modules/genetic-counseling/constants/common';
import { CollapsibleSection } from '@builder';
import SchedulerInquiry from '../../SchedulerInquiry/SchedulerInquiry';
import { StyledCalendarIcon, StyledSectionTitle } from './GeneticScheduler.styles';
import { GeneticSchedulerProps } from './GeneticScheduler.types';
import Scheduler from '../../Scheduler/Scheduler';
import { Inquiry } from '../../SchedulerInquiry/SchedulerInquiry.types';
import { initialState } from '../../SchedulerInquiry/schedulerInquiryReducer';
import SchedulerInquiryContextProvider from '@/modules/genetic-counseling/providers/SchedulerInquiryContext/SchedulerInquiryContext';

const GeneticScheduler: FC<GeneticSchedulerProps> = ({
  handleContactAttempt,
  handleDeclineReferral,
  isContactAttemptSuccess,
  isOnEditionMode,
}) => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);
  const [showScheduler, setShowScheduler] = useState<boolean>(false);
  const [inquiryValues, setInquiryValues] = useState<Inquiry>(initialState);

  const renderTitle = (): ReactNode => {
    return (
      <StyledSectionTitle>
        <StyledCalendarIcon />
        {t('patient_profile.section_scheduler')}
      </StyledSectionTitle>
    );
  };

  return (
    <CollapsibleSection title={renderTitle()} id="scheduler">
      <SchedulerInquiry
        disabled={isOnEditionMode}
        handleContactAttempt={handleContactAttempt}
        handleDeclineReferral={handleDeclineReferral}
        handleInquiryChange={(showScheduler, inquiry) => {
          setShowScheduler(showScheduler);
          setInquiryValues(inquiry);
        }}
        isContactAttemptSuccess={isContactAttemptSuccess}
      />
      <SchedulerInquiryContextProvider value={inquiryValues}>
        {showScheduler && <Scheduler />}
      </SchedulerInquiryContextProvider>
    </CollapsibleSection>
  );
};

export default GeneticScheduler;
